import "../QuoteForm.css";

function TermsSection() {
  return (
    <div className="terms-section">
      <h2>견적 조건 및 유의사항</h2>
      <div className="terms-content">
        <div>
          <h3>결제 조건</h3>
          <ul>
            <li>
              비용 지급 일정은 아래와 같으며, '저작자'는 각 기일에 맞춰 비용을
              지급해야 합니다.
            </li>
            <li>
              <strong>계약금 :</strong> 견적 금액의 30% (계약 체결 후 7일 이내)
            </li>
            <li>
              <strong>중도금 :</strong> 확정 금액의 40% (최종 편집본 완료 후 7
              일 이내)
            </li>
            <li>
              <strong>잔금 :</strong> 확정 금액의 30% (서점 유통 전 안내 후 7 일
              이내)
            </li>
          </ul>
        </div>
        <div>
          <h3>작업 기간</h3>
          <ul>
            <li>
              <strong>총 소요 기간:</strong> 편집 가능한 원고 제출 후 3개월
            </li>
            <li>
              <strong>1단계 - 원고 검토 및 기획 (2주):</strong> 기획 방향성 및
              일정 확정
            </li>
            <li>
              <strong>2단계 - 편집 및 감수 (4주):</strong> 선택 서비스에 따라
              진행
            </li>
            <li>
              <strong>3단계 - 디자인 및 레이아웃 (3주):</strong> 템플릿 적용
              또는 커스텀 디자인
            </li>
            <li>
              <strong>4단계 - 파일 제작 (2주):</strong> 플랫폼별 최적화 파일
              생성
            </li>
            <li>
              <strong>5단계 - 등록 및 검수(전자책) (2주):</strong> 플랫폼 등록
              및 최종 검수
            </li>
            <li>
              <strong>6단계 - 출간 및 유통(종이책) (3주):</strong> 정식 출간 및
              판매 시작
            </li>
          </ul>
        </div>
        <div>
          <h3>유의사항</h3>
          <ul>
            <li>본 견적서는 발행일로부터 30일간 유효합니다.</li>
            <li>원고의 상태 및 분량에 따라 추가 비용이 발생할 수 있습니다.</li>
            <li>
              저작권은 저자에게 있으며, 출판권과 배타적발행권은 출판사에
              있습니다.
            </li>
            <li>인쇄 후 교정 요청 시 별도 비용이 발생합니다.</li>
            <li>마케팅 서비스 효과는 보장되지 않습니다.</li>
          </ul>
        </div>
        <div>
          <h3>* [반기획 출판], [기획 출판] 견적은 출판 상담 바랍니다.</h3>
        </div>
      </div>
    </div>
  );
}

export default TermsSection;
